import { render, staticRenderFns } from "./DataRailModel.vue?vue&type=template&id=2bb6e458&scoped=true"
import script from "./DataRailModel.vue?vue&type=script&lang=js"
export * from "./DataRailModel.vue?vue&type=script&lang=js"
import style0 from "./DataRailModel.vue?vue&type=style&index=0&id=2bb6e458&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6e458",
  null
  
)

export default component.exports